module.exports = __webpack_public_path__ + "static/img/bankcard.caa0f761.svg";